import { IUserDetail, UserDetailUtil } from 'shared/models';
import { SEOUrlBuilder } from '~/utils/build-seo-url';
import { Person } from 'schema-dts';

export const PersonJsonLdUtil = {
  fromUserDetail: (props: { user: IUserDetail; buildSEOLink: SEOUrlBuilder }): Person => {
    const { user, buildSEOLink } = props;

    const description = user.description.replace(/\s+/g, ' ');
    const canonicalUrl = buildSEOLink(UserDetailUtil.getPath(user), { fullUrl: true });

    return {
      '@type': 'Person',
      name: user.nickName,
      alternateName: user.linkName,
      description,
      mainEntityOfPage: {
        '@id': canonicalUrl,
        '@type': 'ProfilePage',
      },
      identifier: {
        '@type': 'PropertyValue',
        propertyID: 'Username',
        value: user.linkName,
      },
      image: {
        '@type': 'ImageObject',
        contentUrl: user.avatar,
      },
      interactionStatistic: [
        {
          '@type': 'InteractionCounter',
          interactionType: {
            '@type': 'LikeAction',
          },
          userInteractionCount: user.dugCount + user.favoredCount,
        },
        {
          '@type': 'InteractionCounter',
          interactionType: {
            '@type': 'FollowAction',
          },
          userInteractionCount: user.followerCount,
        },
        {
          '@type': 'InteractionCounter',
          interactionType: {
            '@type': 'WriteAction',
          },
          userInteractionCount: user.postCount,
        },
      ],
    };
  },
};
